import { render, staticRenderFns } from "./Picture_management.vue?vue&type=template&id=4a60a56e"
import script from "./Picture_management.vue?vue&type=script&lang=js"
export * from "./Picture_management.vue?vue&type=script&lang=js"
import style0 from "./Picture_management.vue?vue&type=style&index=0&id=4a60a56e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports